import { put, call, takeLatest } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { SHOW_LOADER, HIDE_LOADER } from './../../../common/actionConstants';

export function* fetchOrgAccessData() {
    try {
        yield put({ type: SHOW_LOADER });
        const orgAccessData = yield call(Api.getOrgAccess, ActionConstants.FETCH_ORG_ACCESS_DATA_REQUEST);
        yield put({
            type: ActionConstants.FETCH_ORG_ACCESS_DATA_SUCCESS,
            payload: orgAccessData
        })

    }
    catch (error) {

    }
    finally {
        yield put({ type: HIDE_LOADER });
    }
}

export function* updateOrgAccessData({payload}) {
    try{
        yield put({ type: SHOW_LOADER });
        const response = yield call(Api.updateOrgAccess,ActionConstants.UPDATE_ORG_ACCESS_DATA_REQUEST,payload);
        if (response.status == 200){
            window.location.reload()
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: HIDE_LOADER });
    }
}

export default [
    takeLatest(ActionConstants.FETCH_ORG_ACCESS_DATA_REQUEST, fetchOrgAccessData),
    takeLatest(ActionConstants.UPDATE_ORG_ACCESS_DATA_REQUEST,updateOrgAccessData)
];

